export default __webpack_public_path__ + "static/heroSectionImgBg-4d8c8ddf34680d5890d99947db596565.png";